export const WIN = {
    name: 'MATCH_WINNER',
    code: '218'
};

export const POINTS = {
    name: 'TOTAL_POINTS',
    code: '220'
};
export const SCORE= {
    name: 'CORRECT_SCORE',
    code: '221'
};


// export const DOUBLE_CHANCE_1 = '13' export const DOUBLE_CHANCE_2 = '14'
export const WINNING_MARGIN = {
    name: 'WINNING_MARGIN',
    code: '222'
};


export const HANDICAP = {
    name: 'HANDICAP_TENNIS',
    code: '219'
};


export const ALL_TENNIS_MARKETS = [
    WIN,
    POINTS,
    SCORE,
    WINNING_MARGIN,
    HANDICAP,
];


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/tennis/constants/marketTypes.js